import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

const CTASection = () => {
  return (
    <div className="relative my-20 mx-3 sm:my-32 sm:mx-10 md:m-28 py-10 px-5 sm:p-10 text-white bg-[var(--primarycolor)] flex items-center justify-center overflow-hidden rounded-3xl">
      {/* Floating Background Elements */}
      {/* <div className="absolute top-20 left-10 w-72 h-72 bg-red-500/5 rounded-full blur-3xl animate-pulse"></div>
      <div className="absolute bottom-32 right-20 w-96 h-96 bg-red-400/8 rounded-full blur-3xl animate-pulse delay-1000"></div>
      <div className="absolute top-1/3 right-10 w-48 h-48 bg-red-300/6 rounded-full blur-2xl animate-pulse delay-500"></div> */}
      
      {/* Main Content Container */}
      <div className="relative max-w-4xl mx-auto px-6 text-center">
        {/* Decorative Line */}
        {/* <div className="w-24 h-px bg-gradient-to-r from-transparent via-red-500 to-transparent mx-auto mb-12 opacity-60"></div> */}
        
        {/* Main Heading */}
        <h2 className="text-4xl sm:text-5xl md:text-6xl font-extralight tracking-tight  mb-8 leading-tight">
          Ready to Experience
          <span className="block  font-normal mt-2">
            Dignity Living?
          </span>
        </h2>
        
        {/* Description */}
        <p className="text-base sm:text-lg md:text-xl leading-relaxed max-w-3xl mx-auto mb-5 sm:mb-10 font-light">
          Experience the perfect blend of independence, care, and community in this premium senior living destination. 
          Connect with us today to learn more about creating a fulfilling lifestyle ahead.
        </p>
        
        {/* CTA Button */}
        <div className="relative inline-block group">
          <Link to='/contact'><button
            className="relative bg-white text-black px-4 sm:px-6 py-2 sm:py-3 rounded-full font-medium text-base sm:text-lg transition-all duration-500 transform flex items-center sm:gap-4 "
          >
            Connect With Us
            <div className="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center group-hover:bg-white/30 transition-all duration-300">
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform duration-300" />
            </div>
          </button></Link>
        </div>
        
        {/* Subtle Animation Elements */}
        <div className="absolute -bottom-20 left-1/2 transform -translate-x-1/2">
          <div className="flex space-x-2">
            <div className="w-1.5 h-1.5 bg-red-400 rounded-full animate-bounce"></div>
            <div className="w-1.5 h-1.5 bg-red-400 rounded-full animate-bounce delay-75"></div>
            <div className="w-1.5 h-1.5 bg-red-400 rounded-full animate-bounce delay-150"></div>
          </div>
        </div>
      </div>
      
      {/* Geometric Decorations */}
      {/* <div className="absolute top-1/4 left-8 w-2 h-2 bg-red-500 rounded-full opacity-40 animate-ping"></div>
      <div className="absolute bottom-1/3 right-12 w-3 h-3 border border-red-400 rounded-full opacity-30 animate-spin" style={{animationDuration: '8s'}}></div>
      <div className="absolute top-1/2 left-16 w-1 h-1 bg-red-600 rounded-full opacity-50 animate-pulse"></div> */}
    </div>
  );
};

export default CTASection;